import React from 'react';
import styled from 'styled-components';
import BubbleIncludedServices from 'src/components/Bubbles/BubbleIncludedServices';
import WhatIncludedInPrice from 'src/components/WhatIncludedInPrice';
import { useCurrency } from '@lt/localization';
import PriceBadge from '../../components/PriceBadge';

const BUTTON_HEIGHT = '38px';

const StyledContainer = styled.span`
  display: inline-block;
  vertical-align: top;
`;

const StyledPrice = styled.span`
  margin-right: 10px;
  display: inline-block;
  height: ${BUTTON_HEIGHT};
  line-height: ${BUTTON_HEIGHT};
  vertical-align: top;
`;

const StyledTooltip = styled.span`
  display: inline-block;
  height: ${BUTTON_HEIGHT};
  font-size: 12px;
  line-height: ${BUTTON_HEIGHT};
  vertical-align: top;
  color: ${({ theme }) => theme.colors.greyLight};
`;

const PriceBadgeContainer = ({ fetching, isHotelOnly, value, ...props }) => {
  const { code, symbol } = useCurrency();
  if (!value && !fetching) {
    return null;
  }

  return (
    <StyledContainer>
      <StyledPrice>
        <PriceBadge
          value={value}
          currencyCode={code}
          currencySymbol={symbol}
          {...props}
        />
      </StyledPrice>
      {!isHotelOnly && (
        <StyledTooltip>
          <BubbleIncludedServices placement="bottom">
            <WhatIncludedInPrice />
          </BubbleIncludedServices>
        </StyledTooltip>
      )}
    </StyledContainer>
  );
};

export default PriceBadgeContainer;
